import { Component, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import {
	FormGroup,
	NG_VALUE_ACCESSOR,
	ControlValueAccessor
} from '@angular/forms';

@Component({
	selector: 'app-checkbox-input',
	templateUrl: './checkbox-input.component.html',
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CheckboxInputComponent),
			multi: true
		}
	],
	styleUrls: ['./checkbox-input.component.css'],
	host: {
		class: 'app-checkbox-input'
	},
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxInputComponent implements ControlValueAccessor {
	@Input()
	label = 'Checkbox label';

	@Input()
	labelKey;
	
	@Input()
	hideLabel = false;

	@Input()
	align_right = false;

	@Input()
	ngClasses;

	@Input()
	checked = null;

	@Input() disabledForm = false;
	@Input() parentForm: FormGroup = null;
	@Input() formControlName = null;
	@Input() formArrayName = null;
	@Input() id = null;

	// The internal data model
	private innerValue = false;

	// Placeholders for the callbacks which are later provided
	// by the Control Value Accessor
	private onTouchedCallback: () => {};
	private onChangeCallback: (_: any) => void = (_: any) => {};

	constructor() {
	}

	// get accessor
	get value(): any {
		return this.innerValue;
	}

	// set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.onChangeCallback(v);
		}
	}

	// Set touched on blur
	onBlur() {
		this.onTouchedCallback();
	}

	// From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	// From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	// From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}
}
